<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chaptitle" id="ch2"><a id="page_19"></a>II.</h2>
<h2 class="chaptitle-1a">FROM THE ORIENT<a id="page_20"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Chapter02.vue?2ac44bb4